<template>
  <div>
    <NavabrSaas />
    <section class="bg-half-170 d-table w-100 bg-light">
      <div class="container">
        <div class="row mt-5 justify-content-center">
          <div class="col-lg-12 text-center">
            <div class="pages-heading">
              <h4 class="title mb-0">Terms of Service</h4>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-9">
            <div class="card shadow rounded border-0">
              <div class="card-body">
                <h5 class="card-title">Last Updated: {{ lastUpdated }}</h5>
                
                <p>Please read these Terms of Service ("Terms") carefully before using the TafiCloud platform and services.</p>
                
                <h5 class="mt-4">Acceptance of Terms</h5>
                <p>By accessing or using TafiCloud, you agree to be bound by these Terms. If you disagree with any part of the Terms, you may not access the service.</p>
                
                <h5 class="mt-4">Description of Service</h5>
                <p>TafiCloud provides cloud storage with AI-driven search capabilities and SDK integration for developers and businesses. We reserve the right to modify or discontinue, temporarily or permanently, the service with or without notice.</p>
                
                <h5 class="mt-4">User Accounts</h5>
                <p>When you create an account with us, you must provide accurate, complete, and current information. You are responsible for safeguarding the password and for all activities that occur under your account.</p>
                
                <h5 class="mt-4">Content</h5>
                <p>Our service allows you to store, share, and manage content. You retain all rights to your content, but you grant us a license to use, host, and display your content solely for the purpose of providing the service to you.</p>
                <p>You are solely responsible for the content you upload, and you agree not to upload content that:</p>
                <ul>
                  <li>Infringes on intellectual property rights</li>
                  <li>Contains illegal material</li>
                  <li>Contains malware or viruses</li>
                  <li>Violates the privacy or rights of others</li>
                </ul>
                
                <h5 class="mt-4">Subscription and Payments</h5>
                <p>Some aspects of the service may be offered on a subscription basis. Payment will be charged to your chosen payment method at the confirmation of purchase. Subscriptions automatically renew unless canceled at least 24 hours before the end of the current period.</p>
                
                <h5 class="mt-4">Limitation of Liability</h5>
                <p>In no event shall TafiCloud, its directors, employees, partners, agents, suppliers, or affiliates be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses.</p>
                
                <h5 class="mt-4">Governing Law</h5>
                <p>These Terms shall be governed by the laws of the jurisdiction in which TafiCloud is established, without regard to its conflict of law provisions.</p>
                
                <h5 class="mt-4">Changes to Terms</h5>
                <p>We reserve the right to modify these Terms at any time. We will provide notice of any significant changes. Your continued use of the service after such modifications constitutes your acceptance of the revised Terms.</p>
                
                <h5 class="mt-4">Contact Us</h5>
                <p>If you have any questions about these Terms, please contact us at <a href="mailto:legal@taficloud.com">legal@taficloud.com</a>.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    
    <FooterTafiCloud />
  </div>
</template>

<script>
import NavabrSaas from '@/components/Navbar/Navabr-saas.vue';
import FooterTafiCloud from '@/components/Footer/Footer-TafiCloud.vue';

export default {
  name: "TermsOfService",
  components: {
    NavabrSaas,
    FooterTafiCloud
  },
  data() {
    return {
      lastUpdated: "June 1, 2024"
    }
  }
}
</script>

<style lang="scss" scoped>
.section {
  padding-top: 60px;
}
</style>